import { useEffect, useState } from "react";
import Navbar from "../components/Navbaar";
import Footer from "../components/Footer";
import SEO from "../components/SEO/SEO";
import ReviewForm from "../components/ReviewForm";
import StarRating from "../components/StarRating";
import { subscribeToPublishedReviews } from "../services/reviewService";
import styles from "./Reviews.module.css";

function formatDate(ts) {
  if (!ts?.toDate) return "";
  return ts.toDate().toLocaleDateString("en-NZ", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
}

function Reviews() {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = subscribeToPublishedReviews(
      (data) => {
        setReviews(data);
        setLoading(false);
      },
      () => setLoading(false)
    );
    return unsubscribe;
  }, []);

  return (
    <>
      <SEO
        title="Reviews | BOI Gardens & Car Cleaning"
        description="See what customers say about BOI Gardens & Car Cleaning in Kerikeri, and leave your own review."
      />

      <Navbar />

      <main className={styles.page}>
        <div className={styles.bg} aria-hidden="true" />

        <div className={styles.wrap}>
          <div className={styles.head}>
            <span className="eyebrow">Reviews</span>
            <h1>How did we do?</h1>
            <p>
              Leave a star rating and a quick word — it helps other locals
              decide and it helps us know what's working.
            </p>
          </div>

          <ReviewForm />

          <div className={styles.listHead}>
            <h2>What customers are saying</h2>
          </div>

          {!loading && reviews.length === 0 && (
            <p className={styles.empty}>No reviews published yet — be the first!</p>
          )}

          <div className={styles.list}>
            {reviews.map((r) => (
              <div key={r.id} className={styles.reviewCard}>
                <div className={styles.reviewTop}>
                  <span className={styles.reviewName}>{r.name}</span>
                  <span className={styles.reviewDate}>{formatDate(r.createdAt)}</span>
                </div>
                <StarRating value={r.rating} size={18} />
                <p className={styles.reviewText} style={{ marginTop: 10 }}>
                  {r.feedback}
                </p>
              </div>
            ))}
          </div>
        </div>
      </main>

      <Footer />
    </>
  );
}

export default Reviews;
